import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  templateUrl: './fun-facts-modal.component.html',
  styleUrls: ['./fun-facts-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FunFactsModalComponent {
  public fact;
  constructor(private router: Router, @Inject(MAT_DIALOG_DATA) public data) {
    this.fact = data.fact;
  }
}
